import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { State } from './styled'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface IProps {
  value: boolean
  advance: number
}

const CourseApproval = ({ value, advance }: IProps) => {
  const [title, setTitle] = useState('')
  const [color, setColor] = useState('')

  useEffect(() => {
    switch (advance) {
      case 1:
        setTitle('Por completar')
        setColor('#FFD033')
        break
      case 2:
        if (value) {
          setTitle('Aprobado')
          setColor('#00B47C')
        } else {
          setTitle('Reprobado')
          setColor('#FF5B55')
        }
        break
      default:
        setTitle('--')
        break
    }
  }, [value, advance])

  return (
    <State color={color} height={32}>
      {title !== '--' && <FontAwesomeIcon icon={faCircle as IconProp} />}
      {title}
    </State>
  )
}

export default CourseApproval
